function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * Provides logger functionality for Oskari
 * var log = Oskari.log('MyLog');
 * log.enableDebug(true);
 * log.debug('my debug message');
 * log.warn('my warn message');
 * log.error('my error message');
 */
function getConsole() {
  return console;
}
var hasConsole = !!getConsole();
// Set to true to enable timestamps in log messages
var _inclTimestamp = false;

/** Utility methods for logger */
function _logMsg(args) {
  var level = args.shift();
  if (!hasConsole || !getConsole()[level] || !getConsole()[level].apply) {
    // maybe gather messages and provide a custom debug console?
    return;
  }
  getConsole()[level].apply(getConsole(), args);
}
function ts() {
  if (!_inclTimestamp) {
    return '';
  }
  var date = new Date();
  return date.toLocaleTimeString() + '.' + date.getUTCMilliseconds() + ' ';
}
function _doLogging(logName, logLevel, logMessages) {
  var header = ts() + logName + ':';
  // prefix messages with logName
  logMessages.unshift(header);
  // prefix logName + messages with logLevel
  logMessages.unshift(logLevel);
  // write to log
  _logMsg(logMessages);
}

// this will be shared between all loggers
var _globalDebug = false;
// these will be private and switched/logger
var _isDebug = new WeakMap();
var _deprecatedMessages = new WeakMap();
var Logger = /*#__PURE__*/function () {
  function Logger(name) {
    _classCallCheck(this, Logger);
    this.name = name || 'Logger';
  }
  return _createClass(Logger, [{
    key: "enableDebug",
    value: function enableDebug(enable) {
      _isDebug.set(this, !!enable);
    }
  }, {
    key: "enableGlobalDebug",
    value: function enableGlobalDebug(enable) {
      _globalDebug = !!enable;
    }
  }, {
    key: "enableTimestamps",
    value: function enableTimestamps(enable) {
      _inclTimestamp = !!enable;
    }
  }, {
    key: "isDebug",
    value: function isDebug() {
      return _globalDebug || _isDebug.get(this);
    }
  }, {
    key: "debug",
    value: function debug() {
      if (!this.isDebug()) {
        return;
      }
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _doLogging(this.name, 'debug', args);
    }
  }, {
    key: "info",
    value: function info() {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }
      _doLogging(this.name, 'log', args);
    }
  }, {
    key: "warn",
    value: function warn() {
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }
      _doLogging(this.name, 'warn', args);
    }
  }, {
    key: "error",
    value: function error() {
      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args[_key4] = arguments[_key4];
      }
      _doLogging(this.name, 'error', args);
    }
  }, {
    key: "deprecated",
    value: function deprecated(name, extraInfo) {
      var deprecatedMessagesSent = _deprecatedMessages.get(this) || {};
      if (!deprecatedMessagesSent[name]) {
        deprecatedMessagesSent[name] = 0;
        _deprecatedMessages.set(this, deprecatedMessagesSent);
      }
      deprecatedMessagesSent[name]++;
      if (deprecatedMessagesSent[name] > 1) {
        // Fall silent after 1 warnings/deprecation
        return;
      }
      _doLogging(this.name, 'warn', [name + ' will be removed in future release.', extraInfo || 'Remove calls to it.']);
    }
  }]);
}();
export { Logger as default };